
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Exercise, SetData } from "../types";

export const useRoutineData = (routineId: string | undefined) => {
  return useQuery({
    queryKey: ["routine", routineId],
    queryFn: async () => {
      if (!routineId) throw new Error("No routine ID provided");

      const { data: routine, error } = await supabase
        .from("routines")
        .select(`
          *,
          exercises (*)
        `)
        .eq("id", routineId)
        .single();

      if (error) throw error;
      if (!routine) throw new Error("Routine not found");

      // Transform the exercises data to ensure all fields are properly typed, pero sin valores predeterminados
      // Sort exercises by position to ensure correct order
      const transformedExercises = routine.exercises
        .sort((a: any, b: any) => a.position - b.position)
        .map((exercise: any) => ({
          ...exercise,
          set_data: exercise.set_data?.map((set: any) => ({
            reps: Number(set.reps),
            weight: Number(set.weight)
          })) || [],
          // Mantener los valores tal como vienen de la base de datos
          exercise_rest_time: exercise.exercise_rest_time !== null ? Number(exercise.exercise_rest_time) : null,
          set_rest_time: exercise.set_rest_time !== null ? Number(exercise.set_rest_time) : null
        })) as Exercise[];

      return {
        ...routine,
        exercises: transformedExercises
      };
    },
    enabled: !!routineId
  });
};
